import { ELocalStorageKey } from '../types/enums'
import request, { IWorkspaceResponse } from '/@/api/http/request'
import { mapLayers } from '/@/constants/mock-layers'
import { elementGroupsReq, PostElementsBody, PutElementsBody } from '/@/types/mapLayer'
const PREFIX = '/map/api/v1'
type UnknownResponse = Promise<IWorkspaceResponse<unknown>>
// get elements group
// export const getLayers = async (reqParams: elementGroupsReq): UnknownResponse => {
//   const url = `${PREFIX}/workspaces/${workspace_id}/element_groups`
//   const result = await request.get(url, {
//     params: {
//       group_id: reqParams.groupId,
//       is_distributed: reqParams.isDistributed
//     },
//   })
//   return result.data
// }
export const getLayers = async (reqParams: elementGroupsReq): UnknownResponse => {
  return mapLayers
}

// Get elements groups request
export const getElementGroupsReq = async (body: elementGroupsReq): Promise<IWorkspaceResponse<any>> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/` + workspace_id + '/element-groups'
  const result = await request.get(url, {
    params: {
      group_id: body.groupId,
      is_distributed: body.isDistributed,
    }
  })
  return result.data
}
// add element
export const postElementsReq = async (pid: string, body: PostElementsBody): Promise<IWorkspaceResponse<{ id: string }>> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/` + workspace_id + `/element-groups/${pid}/elements`
  const result = await request.post(url, body)
  return result.data
}
// Update map element request
export const updateElementsReq = async (id: string, body: PutElementsBody): Promise<IWorkspaceResponse<{ id: string }>> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/` + workspace_id + `/elements/${id}`
  const result = await request.put(url, body)
  return result.data
}
// Delete map element
export const deleteElementReq = async (id: string, body: {}): Promise<any> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/` + workspace_id + `/elements/${id}`
  const result = await request.delete(url, body)
  return result.data
}

// Delete layer elements
export const deleteLayerEleReq = async (id: string, body: {}): Promise<any> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/` + workspace_id + `/element-groups/${id}/elements`
  const result = await request.delete(url, body)
  return result.data
}

// Create a new element group
export const postGroupReq = async (name: string, parentId?: string, isDistributed?: boolean): Promise<IWorkspaceResponse<{ id: string }>> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/` + workspace_id + '/groups'
  const body: Record<string, any> = { name }
  if (parentId) body.parent_id = parentId
  if (isDistributed !== undefined) body.is_distributed = isDistributed
  const result = await request.post(url, body)
  return result.data
}

// Update the is_distributed flag on a group
export const patchGroupDistributedReq = async (groupId: string, isDistributed: boolean): Promise<any> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/${workspace_id}/groups/${groupId}/distributed`
  const result = await request.patch(url, { is_distributed: isDistributed })
  return result.data
}

// Delete a group and all its elements
export const deleteGroupReq = async (groupId: string): Promise<any> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/` + workspace_id + `/element-groups/${groupId}`
  const result = await request.delete(url, {})
  return result.data
}

// Move a group to a new parent
export const updateGroupReq = async (groupId: string, parentId: string | null): Promise<any> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/` + workspace_id + `/element-groups/${groupId}`
  const result = await request.put(url, { parent_id: parentId ?? '' })
  return result.data
}

/** Merge sourceGroupId into targetGroupId: elements are re-parented, source is deleted. */
export const mergeGroupReq = async (sourceGroupId: string, targetGroupId: string): Promise<any> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/${workspace_id}/element-groups/${sourceGroupId}/merge-into/${targetGroupId}`
  const result = await request.post(url, {})
  return result.data
}

// Move a single element to a different group (creator username is preserved)
export const moveElementReq = async (elementId: string, targetGroupId: string): Promise<any> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/${workspace_id}/elements/${elementId}/move`
  const result = await request.patch(url, { target_group_id: targetGroupId })
  return result.data
}

// ----------------------------------------------------------------- annotation snapshots

// Archive all live annotations into a new snapshot and clear the live layer (web + RC)
export const createSnapshotReq = async (): Promise<IWorkspaceResponse<any>> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/${workspace_id}/snapshots`
  const result = await request.post(url, {})
  return result.data
}

// List all snapshots of the workspace (most recent first)
export const getSnapshotsReq = async (): Promise<IWorkspaceResponse<any>> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/${workspace_id}/snapshots`
  const result = await request.get(url)
  return result.data
}

// Read-only content of one snapshot (grouped like the live map)
export const getSnapshotContentReq = async (snapshotId: string): Promise<IWorkspaceResponse<any>> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/${workspace_id}/snapshots/${snapshotId}`
  const result = await request.get(url)
  return result.data
}

// Restore archived elements into the live layer (web + RC).
// Pass exactly one of { group_id } (whole group) or { element_id } (single annotation).
export const restoreSnapshotReq = async (snapshotId: string, body: { group_id?: string, element_id?: string }): Promise<IWorkspaceResponse<any>> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/${workspace_id}/snapshots/${snapshotId}/restore`
  const result = await request.post(url, body)
  return result.data
}

// Force the RC (Pilot 2) to re-fetch annotations from the server (MAP_GROUP_REFRESH).
// Pass a groupId to re-push only that folder; omit it to re-push every folder.
// NB: this pushes server → RC only. It never makes the RC upload; capturing RC-only
// pins must be started from the RC (Pilot page reloads its Map module).
export const mapSyncNotifyReq = async (groupId?: string): Promise<any> => {
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const url = `${PREFIX}/workspaces/${workspace_id}/map-sync-notify`
  const result = await request.post(url, {}, {
    params: groupId ? { group_id: groupId } : {}
  })
  return result.data
}

export const putUserLocation = async (lat: number, lng: number): Promise<any> => {
  const wsId = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const result = await request.put(`${PREFIX}/workspaces/${wsId}/user-location`, { lat, lng })
  return result.data
}

export const deleteUserLocation = async (): Promise<any> => {
  const wsId = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const result = await request.delete(`${PREFIX}/workspaces/${wsId}/user-location`, {})
  return result.data
}

export const getUserLocations = async (): Promise<any> => {
  const wsId = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const result = await request.get(`${PREFIX}/workspaces/${wsId}/user-locations`)
  return result.data
}

// Trail history per user: { userId: [[lng, lat, ts], ...] } — used to rebuild
// the position trace lines after a page reload.
export const getUserLocationHistories = async (): Promise<any> => {
  const wsId = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  const result = await request.get(`${PREFIX}/workspaces/${wsId}/user-location-histories`)
  return result.data
}
